import React from 'react';
import { BusinessCase } from '../../services/constants/constants';
import { titlecase, removeUnderscore } from '../../services/utils/Helper';
import CustomizedTooltip from '../atoms/Tooltip/CustomizedTooltip';
import './FormattedBusinessCase.css';

const FormattedBusinessCase = (props) => {
  const { businessCase } = props;

  const getClassName = () => {
    let className = '';

    switch (businessCase) {
      case BusinessCase.Renewal:
        className = 'renewal';
        break;
      case BusinessCase.Invalid:
        className = 'invalid';
        break;
      case BusinessCase.New_Business:
        className = 'new-business';
        break;
      case BusinessCase.Renewal_Across_Different_Carrier:
        className = 'renewal-across-different-carrier';
        break;
      case BusinessCase.Automated_Renewal:
        className = 'automated-renewal';
        break;
    
      default:
        className = '';
        break;
    }

    return className;
  };

  const getBusinessCaseFormattedValue = (status) => {
    return removeUnderscore(titlecase(status));
}

  return (
    <CustomizedTooltip text={getBusinessCaseFormattedValue(businessCase)}>
      <span className={`${getClassName()}`} style={{padding: '0.125rem 0.5rem', fontWeight: '500', borderRadius: '0.25rem'}}>{getBusinessCaseFormattedValue(businessCase)}</span>
    </CustomizedTooltip>
  );
}

export default React.memo(FormattedBusinessCase);
